module.exports = __webpack_public_path__ + "img/users-icon.b7e00caa.png";